import {StartCanvasProject} from "./front/reactI";

window.onload = function() {
    StartCanvasProject();
}